import { HttpClient, HttpParams } from '@angular/common/http';
import { ModalIframeComponent } from './../modal-iframe/modal-iframe.component';
import { FieldGroupModel } from 'app/models/shared/fieldGroup.model';
import { FieldGroupComponent } from './../field-group/field-group.component';
import { Component, OnInit, Input } from '@angular/core';
import { ModalController, NavParams, AlertController, PopoverController, NavController } from '@ionic/angular';
import { Constants } from 'app/utility/constants';

import { Browser } from '@capacitor/browser';
import { ModalDetailsPopover } from './modal-details.popover';

@Component({
	selector: 'app-modal-details',
	templateUrl: './modal-details.component.html',
	styleUrls: ['./modal-details.component.scss'],
	standalone: false
})
export class ModalDetailsComponent implements OnInit
{

	@Input() title: string;
	@Input() subtitle: string;
	@Input() back: boolean = false;
	@Input() light: boolean = false;
	@Input() buttons: [];
	@Input() buttonsInPopover: boolean = false;

	@Input() field_groups: FieldGroupModel[];

    @Input() classes: string = "";

	constructor(
		public modalController: ModalController,
		public navParams: NavParams,
		private httpClient: HttpClient,
		private alertController: AlertController,
		private popoverController: PopoverController,
        private navCtrl: NavController
	)
	{

	}

	ngOnInit()
	{
		// console.log(this.navParams);   
	}

	public dismissModal(button: any)
	{
		if (button.disabled) return;
		// Dismiss the top modal returning some data object
		this.modalController.dismiss({
			'result': button.name
		});
	}

	showLoading: boolean = false;
	public async handleFieldClicked(ev: any)
	{
		switch (ev.detail.type)
		{
			case "html":
				//launch the html viewer
				var apiUrl = ev.detail.detailObject;
				this.showLoading = true;

				let httpParams = new HttpParams();

				this.httpClient.get<string>(Constants.ApiUrl + apiUrl, { params: httpParams }).subscribe({
					next: async x =>
					{
						this.showLoading = false;
						await Browser.open({ url: x });
					},
					error: err =>
					{
						this.showLoading = false;
					}
                });
				break;
			case "wholesale-contact":
				// Dismiss the top modal returning some data object
				this.modalController.dismiss({
					'fieldClicked': ev.detail
				});
				break;
			case "path":
				// Dismiss the top modal returning some data object
				this.modalController.dismiss({});
				break;
		}
	}

	public objectLoadError: boolean = false;
	public handleError(error: any): void
	{
		var errorTitle = '';
		var errorMessage = '';
		var showAlert = false;
		var showBack = false;
		var showLogin = false;
		console.error(error);
		var dtoError;
		if (error.error && error.error.entityDataJson) dtoError = JSON.parse(error.error.entityDataJson);
		// this.skeleton = false;
		var statusCode = 500;
		if (dtoError && dtoError.Message != null)
		{
			//api error
			errorMessage = dtoError.Message;
			showAlert = true;
			statusCode = dtoError.StatusCode;

			switch (statusCode)
			{
				case 404:
					errorTitle = "Not Found Error";
					showBack = true;
					break;
				case 400:
					errorTitle = "Validation Error";
					break;
				case 401:
					errorTitle = "Login Error"; //we shouldn't get this
					this.navCtrl.navigateRoot('/login');
					break;
				case 403:
					errorTitle = "Security Error";
					showBack = true;
					break;
				default:
					errorTitle = "Error";
					break;
			}
		}
		else
		{
			if (error.status)
			{
				statusCode = error.status;
			}
			switch (statusCode)
			{
				case 404:
					errorTitle = "Not Found Error";
					errorMessage = "Resource was not found";
					showBack = true;
					break;
				default:
					errorTitle = error.title ? error.title : "Error";
					errorMessage = error.message;
					if (error.name == "TimeoutError")
					{
						errorTitle = "Timeout Error"
						errorMessage = "Unable to load resource in a timely manner. There may be an issue with connecting to Motorcentral.<br/><br/>If this error continues please contact our support team.";
					}
					else if (error.name == "HttpErrorResponse")
					{
						errorTitle = "Resource Error"
						errorMessage = "Failed to load resource. Please check your internet connection.<br/><br/>If this error continues please contact our support team.";
					}
					break;
			}
		}
		this.objectLoadError = true;
		this.presentAlert(errorTitle, errorMessage, showBack);
	}

	async presentAlert(title: string, message: string, back: boolean = false)
	{
		var buttons =
		{
			text: 'OK',
			role: 'cancel',
			cssClass: 'secondary',
			handler: () =>
			{
			}
		};
		if (back) 
		{
			buttons =
			{
				text: 'Go Back',
				role: 'cancel',
				cssClass: 'secondary',
				handler: () =>
				{
					history.go(-1);
				}
			};
		}
		const alert = await this.alertController.create({
			header: title,
			message: message,
			buttons: [
				buttons
			]
		});

		await alert.present();
	}

	scrollTop: boolean = true;
	ionScrollEvent(ev: any)
	{
		var scrollTop = (ev.detail.scrollTop == 0);
		if (this.scrollTop != scrollTop)
		{
			this.scrollTop = scrollTop;
		}
	}

	async presentPopover(ev: any)
	{
		const popover = await this.popoverController.create({
			component: ModalDetailsPopover,
			event: ev,
			translucent: true,
			componentProps: { buttons: this.buttons }
		});
		await popover.present();

		const { data } = await popover.onWillDismiss();
		if (data)
		{
			this.dismissModal(data);
		}
	}
}
